import { MyProfileTemplate } from '@ideoz/ui';
import { useMyProfile } from './useMyProfile';

/**
 * User-account profile module: renders the shared MyProfileTemplate wired to
 * the web logout / auth / startup-sidebar logic in {@link useMyProfile}.
 */
export function MyProfileModule(): JSX.Element {
  const { user, authDialog, facade } = useMyProfile();

  if (!user) {
    return <div>Loading...</div>;
  }

  return <MyProfileTemplate facade={facade} isWeb authDialogState={authDialog} />;
}
